import { Service } from "../../../service.js";
import { env } from "../../../env.js";

class TotalizadorService extends Service {
  constructor() {
    super();

    this.url = env.url + "totalizador";
  }

  async get(objetoQueryString) {
    const queryString = this.converterObjetoDeFiltrosParaQueryString(objetoQueryString);
    return super.get(`${this.url}/dashboard-cliente-totalizador` + queryString);
  }
}

export const service = new TotalizadorService();
